module.exports = __webpack_public_path__ + "static/media/IMG_3755.ea18c1ac.jpg";